import { jwtDecode } from "jwt-decode";
import Notification from "../components/Notification";
import ssoApiService from "../api/ssoApiService";
import { logout } from "../pages/Auth/Logout";

// --- Kiểm tra token còn hạn ---
export const checkTokenValidity = (token) => {
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    if (decodedToken?.roles) {
      localStorage.setItem("roles", JSON.stringify(decodedToken.roles));
    }
    return decodedToken.exp * 1000 >= Date.now();
  } catch {
    return false;
  }
};

// --- Làm mới token ---
export const refreshToken = async () => {
  try {
    const refreshTokenValue = localStorage.getItem("refreshToken");
    if (!refreshTokenValue) {
      Notification("error", "Không có refreshToken trong localStorage");
      return false;
    }

    const params = { refreshToken: refreshTokenValue };
    const res = await ssoApiService.refreshToken(params);

    if (res?.status && res.data.accessToken) {
      localStorage.setItem("token", res.data.accessToken);
      localStorage.setItem("refreshToken", res.data.refreshToken);
      console.info("Refresh token thành công");
      return true;
    } else {
      console.warn("Refresh token thất bại: phản hồi không hợp lệ");
      Notification(
        "error",
        "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
      );
      logout();
      return false;
    }
  } catch (error) {
    console.error("Lỗi khi refresh token:", error);
    Notification(
      "error",
      "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    );
    return false;
  }
};

// --- Xử lý khi login ---
export const handleLogin = async (token) => {
  const valid = checkTokenValidity(token);
  if (!valid) {
    const refreshDone = await refreshToken();
    if (refreshDone) {
      // window.location.reload();
    } else {
      logout();
    }
  }
};

// --- Giữ lại một số key trong localStorage ---
export const clearLocalStorageExceptKey = (keys) => {
  const valuesToKeep = keys.map((key) => localStorage.getItem(key));
  localStorage.clear();
  keys.forEach((key, i) => {
    if (valuesToKeep[i]) localStorage.setItem(key, valuesToKeep[i]);
  });
};

export { logout };
